import twilioService from '../TwilioService';

export class WebTwilioAdapter {
    constructor() {
        this.service = twilioService;
    }

    async isSupported() {
        return true; // Web is always supported
    }

    async register() {
        if (!this.service.isReady()) {
            await this.service.initialize();
        }
    }

    async connect() {
        if (!this.service.isReady()) {
            await this.service.initialize();
        }
        // Web connect implementation can be added here when needed
        // For now, just ensure service is ready
    }

    async disconnect() {
        // Web disconnect implementation can be added here when needed
    }

    isReady() {
        return this.service.isReady();
    }

    getClient() {
        return this.service.getClient();
    }
}
